import { BaseSearchForm, GroupByResponse } from 'entities'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { ApiSet, useShowApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from 'utils/network/axios'

export type GroupApiSet = ApiSet<GroupByResponse> & { execute: () => void }
export function useGroupApi(path: string, searchForm?: Form<BaseSearchForm>): GroupApiSet {
    const api = useShowApi<GroupByResponse>(new CraifHttpClient(), {
        initialResponse: { groups: [] },
    })

    const execute = (): void => {
        const apiPath = `${path}/group_by/`
        api.execute(apiPath, searchForm?.object)
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm?.object])

    return { ...api, execute: execute }
}
